import { ReactNode } from "react"
import { Link } from "@chakra-ui/react"

type PaymentMethodLinkProps = {
  href: string
  children: ReactNode
}

const PaymentMethodLink = ({
  href,
  children,
}: PaymentMethodLinkProps): JSX.Element => {
  return (
    <Link
      href={href}
      minH="114"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor="white"
      borderRadius="lg"
      transition="background 0.2s ease-out"
      borderWidth="3px"
      borderColor="white"
      _hover={{
        borderColor: "orange",
        transition: "border 0.2s ease-out",
      }}
      px="4"
      py="4"
    >
      {children}
    </Link>
  )
}

export default PaymentMethodLink
